import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Fade from "react-reveal/Fade";
import withReveal from "react-reveal/withReveal";

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${({ $variant }) => ($variant === "row" ? "row" : "column")};
  align-items: ${({ $alignContent }) =>
    $alignContent === "center" ? "center" : "flex-start"};
  justify-content: flex-start;
  width: 100%;
  margin: ${({ $disableMargin }) => ($disableMargin ? "0px" : "40px 0px")};
  padding: ${({ $disableGutters }) => ($disableGutters ? "0px" : "0 20px")};
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || "transparent"};
  color: ${({ textColor }) => textColor};
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    flex-direction: column;
    align-items: center;
    margin: ${({ $disableMargin }) => ($disableMargin ? "0px" : "30px 0px")};
  }
  border-radius: ${({ $borderRadius }) =>
    $borderRadius ? `${$borderRadius}px` : "var(--container-border-radius)"};
  max-width: ${({ $maxWidth }) =>
    $maxWidth === "xl"
      ? "none"
      : $maxWidth === "lg"
        ? "1600px"
        : $maxWidth === "md"
          ? "1180px"
          : $maxWidth === "sm"
            ? "960px"
            : "300px"};
`;

const AnimatedWrapper = withReveal(
  styled.div`
    display: flex;
    flex-direction: ${({ $variant }) =>
      $variant === "row" ? "row" : "column"};
    align-items: ${({ $alignContent }) =>
      $alignContent === "center" ? "center" : "flex-start"};
    justify-content: flex-start;
    width: 100%;
    margin: ${({ $disableMargin }) => ($disableMargin ? "0px" : "40px 0px")};
    padding: ${({ $disableGutters }) => ($disableGutters ? "0px" : "0 20px")};
    background-color: ${({ $backgroundColor }) =>
      $backgroundColor || "transparent"};
    color: ${({ textColor }) => textColor};
    font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
    @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
      flex-direction: column;
      align-items: center;
      margin: ${({ $disableMargin }) => ($disableMargin ? "0px" : "30px 0px")};
    }
    border-radius: ${({ $borderRadius }) =>
      $borderRadius ? `${$borderRadius}px` : "var(--container-border-radius)"};
    max-width: ${({ $maxWidth }) =>
      $maxWidth === "xl"
        ? "none"
        : $maxWidth === "lg"
          ? "1600px"
          : $maxWidth === "md"
            ? "1180px"
            : $maxWidth === "sm"
              ? "960px"
              : "300px"};
  `,
  <Fade bottom fraction={0} />
);

export default function Container({
  children,
  maxWidth,
  disableGutters,
  disableMargin,
  disableAnimation,
  alignContent,
  variant,
  backgroundColor,
  textColor,
  className,
  borderRadius,
}) {
  return !disableAnimation ? (
    <AnimatedWrapper
      $maxWidth={maxWidth}
      $variant={variant}
      $disableGutters={disableGutters}
      $disableMargin={disableMargin}
      $alignContent={alignContent}
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      className={className}
      $borderRadius={borderRadius}
    >
      {children}
    </AnimatedWrapper>
  ) : (
    <Wrapper
      $maxWidth={maxWidth}
      $variant={variant}
      $disableGutters={disableGutters}
      $disableMargin={disableMargin}
      $alignContent={alignContent}
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      className={className}
      $borderRadius={borderRadius}
    >
      {children}
    </Wrapper>
  );
}

Container.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.oneOf(["xl", "lg", "md", "sm", "xs"]),
  disableGutters: PropTypes.bool,
  disableMargin: PropTypes.bool,
  variant: PropTypes.oneOf(["row", "column"]),
  alignContent: PropTypes.oneOf(["center", "flex-start"]),
  disableAnimation: PropTypes.bool,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  className: PropTypes.string,
  borderRadius: PropTypes.string,
};
Container.defaultProps = {
  children: undefined,
  maxWidth: "lg",
  disableGutters: false,
  disableMargin: false,
  variant: "column",
  alignContent: "center",
  disableAnimation: false,
  className: undefined,
};
